module.exports = {"id":"185200","name":"Vasco Fernandes","rating":"74","photo":"./data/images/photos/2/185200.png","club":{"name":"Vitoria Setúbal","logo":"./data/images/clubs/VitoriaSetubal.png"},"positions":["DC","DD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/VascoFernandes0.json
// module id = 4235
// module chunks = 0